/* eslint-disable jsx-a11y/alt-text */
import { Card, CardBody, Button, Spinner } from "reactstrap"

const AnalyticsCard = ({ title, count, icon, onViewClick, isLoading, showViewButton = true, isImageIcon = true }) => {
  const IconComponent = icon;

  return (
    <Card className="border-0 shadow h-100">
      <CardBody className="px-3 py-2">
        <div className="d-flex align-items-center justify-content-between" style={{ height: '70%' }}>
          <div>
            <h4 className="small text-muted mb-1">{title}</h4>
            <h1 className="mb-0 fw-bold">{isLoading ? <Spinner color="primary" style={{ width: "2rem", height: "2rem" }} /> : count}</h1>
          </div>
          {icon && (
            isImageIcon ? (
              <img src={icon} width={44} height={45} />
            ) : (
              <IconComponent size={44} />
            )
          )}
        </div>
        {showViewButton && (
          <div className="d-flex justify-content-end">
            <Button color='primary' onClick={() => onViewClick(title)} style={{ borderRadius: '40px' }}>
              View Details
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default AnalyticsCard
